import { Box, Grid, HStack, Text } from "@chakra-ui/react";
import React from "react";
import {
  entityProfileModalBorders,
  entityProfileModalColors,
} from "../../../../../entityProfileModal/entityProfileModal.theme";

export function EmergencyPreparednessBlock(props: {
  actions?: React.ReactNode;
  children: React.ReactNode;
  title?: string;
}) {
  return (
    <Box>
      {props.title && (
        <HStack
          borderBottom={entityProfileModalBorders.default}
          justifyContent="space-between"
          mb={3}
          pb={2}
        >
          <Text color={entityProfileModalColors.text} fontSize="20px" fontWeight={500}>
            {props.title}
          </Text>
          {props.actions}
        </HStack>
      )}
      <Grid
        gap={4}
        templateColumns={{
          base: "1fr",
          md: "repeat(2, minmax(0, 1fr))",
          xl: "repeat(3, minmax(0, 1fr))",
        }}
      >
        {props.children}
      </Grid>
    </Box>
  );
}
